<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" title="Volver" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" type="submit" title="Guardar" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4>{{editTitle}} Autoridad de Control</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedAutoridad = !isCollapsedAutoridad"
                       [attr.aria-expanded]="!isCollapsedAutoridad" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos Principales
                            <i *ngIf="isCollapsedAutoridad" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedAutoridad" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="card-body">

                        <div class="row">
                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpNombre">Nombre</label>
                                <input formControlName="Descripcion" name="Descripcion" title=""
                                       class="form-control" id="inpDescripcion" type="text" value="" [ngClass]="displayFieldCss('Nombre')" maxlength="100">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','required')">
                                    Descripcion es obligatoria
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <label class="col-form-label required-field" for="inpRefTraces">Ref. Traces</label>
                                <input formControlName="ReferenciaTraces" name="RefTraces" title=""
                                       class="form-control" id="inpRefTraces" type="text" value="" [ngClass]="displayFieldCss('ReferenciaTraces')" maxlength="40">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('ReferenciaTraces','required')">
                                    Referencia Traces es obligatoria
                                </div>
                                <!--TODO emarti69: Tarea para controlar la duplicidad de autoridades en puntos de control-->
                                <!--<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('ReferenciaTraces','registry_duplicated')">
                                    La Referencia Traces ya existe
                                </div>-->
                            </div>
                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpActivo">Activa</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="Activa" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>
                        </div>

                        <div class="row">

                            <div class="form-group col-md-6">
                                <label class="col-form-label" for="inpDireccion">Dirección</label>
                                <input formControlName="Direccion" name="Direccion" title=""
                                       class="form-control" id="inpDireccion" type="text" value="" [ngClass]="displayFieldCss('Direccion')" maxlength="150">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Direccion','required')">
                                    Dirección es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpCiudad">Ciudad</label>
                                <input formControlName="Ciudad" name="Ciudad" title=""
                                       class="form-control" id="inpCiudad" type="text" value="" [ngClass]="displayFieldCss('Ciudad')" maxlength="100">
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpCodigoPostal">Código Postal</label>
                                <input formControlName="CodigoPostal" name="CodigoPostal" title=""
                                       class="form-control" id="inpCodigoPostal" type="text" value="" [ngClass]="displayFieldCss('CodigoPostal')" maxlength="15">
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
